'use strict';
;
export var CompanyCustomerPermission;
(function (CompanyCustomerPermission) {
    CompanyCustomerPermission[CompanyCustomerPermission["COMPANY_DEFAULT"] = 2] = "COMPANY_DEFAULT";
    CompanyCustomerPermission[CompanyCustomerPermission["PERSONAL_TICKETS_ONLY"] = 0] = "PERSONAL_TICKETS_ONLY";
    CompanyCustomerPermission[CompanyCustomerPermission["ALL_COMPANY_TICKETS"] = 1] = "ALL_COMPANY_TICKETS";
})(CompanyCustomerPermission || (CompanyCustomerPermission = {}));
//# sourceMappingURL=user.i.js.map